/* *********************************
 *
 *      画面遷移用空ページ
 *
 ********************************* */
/*-------------------
     モジュールのimport
 ---------------------*/
import { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

/*-------------------
             classのimport
         ---------------------*/

/**
 * 画面遷移用空ページ
 */
class EmptyPage extends Component {
  constructor(props) {
    super(props);
    const { location = { page: '' } } = props;
    const { path = '', search = '' } = location;
    this.state = {
      path,
      search,
    };
  }

  /**
   *一度目の描画終了時に実行される
   *
   * @memberof EmptyPage
   */
  componentDidMount = () => {
    const { history } = this.props;
    const { path, search } = this.state;
    history.replace({
      pathname: path,
      search,
    });
  };

  /**
   *画面遷移用空ページ
   *
   * @memberof DraftConfirmation
   */
  render() {
    return null;
  }
}

EmptyPage.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    path: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
};
export default withRouter(EmptyPage);
